import { BaseFilter, FiltersDeclaration } from '../types/Filters';

/**
 */
export function getDynamicFilterList<Filter extends BaseFilter>(
    dynamicFilters: FiltersDeclaration<Filter>['dynamicFilters']
): Filter[] {
    return (dynamicFilters ?? []).reduce<Filter[]>((acc, filter) => {
        if ('filters' in filter) {
            return acc.concat(getDynamicFilterList(filter.filters));
        }

        return acc.concat(filter);
    }, []);
}
